import { Form, TimePicker } from "antd";
import React from "react";
import dayjs from "dayjs";
import Candidates from "./Candidates";

const format = "HH:mm";
function Auto({ form }) {
  const handleTimeChange = () => {
    const start = form.getFieldValue("stStartTime");
    const duration = form.getFieldValue("duration");
    const gap = form.getFieldValue("gap");

    if (start && duration && gap) {
      const endTime = dayjs(start)
        .add(duration.hour(), "hour")
        .add(duration.minute(), "minute")
        .add(gap.hour(), "hour")
        .add(gap.minute(), "minute");

      form.setFieldsValue({
        stEndTime: endTime,
      });
    }
  };
  return (
    <> 
    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
      <Form.Item
        name="startTime"
        rules={[
          {
            required: true,
            message: "Duration field is required",
          },
        ]}
        label="Start time"
      >
        <TimePicker
          required
          style={{
            width: "100%",
            height: "44px",
          }}
          format={format}
          className="input"
          onChange={handleTimeChange}
        />
      </Form.Item>

      <Form.Item
        name="duration"
        rules={[
          {
            required: true,
            message: "Duration field is required",
          },
        ]}
        label="Duration"
      >
        <TimePicker
          required
          style={{
            width: "100%",
            height: "44px",
          }}
          format={format}
          className="input"
          onChange={handleTimeChange}
        />
      </Form.Item>

      <Form.Item
        name="breakTime"
        rules={[
          {
            required: true,
            message: "Gap between interviewsfield is required",
          },
        ]}
        label="Gap between interviews"
      >
        <TimePicker
          required
          style={{
            width: "100%",
            height: "44px",
          }}
          format={format}
          className="input"
          onChange={handleTimeChange}
        />
      </Form.Item>

      {/* <Form.Item
        name="stEndTime"
        rules={[
          {
            required: false,
            message: "End Time [Auto]",
          },
        ]}
        label="End Time [Auto]"
      >
        <TimePicker
          disabled
          style={{
            width: "100%",
            height: "44px",
          }}
          format={format}
          className="input"
        />
      </Form.Item> */}
    </div>

    <Candidates/>
    </>
  );
}

export default Auto;
